import {ChangeDetectionStrategy,Component,inject,input,LOCALE_ID,output} from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {RouterLink,RouterLinkActive} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {CookieService} from 'ngx-cookie-service';
import {MatDrawer} from '@angular/material/sidenav';
import {AppService} from '../../../app.service';
import {environment} from '../../../../environments/environment';
import {SUPPORTED_LOCALES} from '../../../../locale-preference';

@Component({
	selector:'app-drawer',
	imports:[
		MatToolbarModule,
		MatIconModule,
		MatButtonModule,
		MatListModule,
		MatTooltipModule,
		MatMenuModule,
		RouterLink,
		RouterLinkActive
	],
	templateUrl:'./drawer.html',
	styleUrl:'./drawer.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class DrawerComponent{
	readonly drawerClosed=output<void>();
	readonly drawerInput=input<MatDrawer>();
	readonly appService=inject(AppService);
	readonly currentLocale=inject(LOCALE_ID);
	private readonly document=inject(DOCUMENT);
	private readonly cookieService=inject(CookieService);
	protected readonly environment=environment;

	closeMenu():void{
		this.drawerClosed.emit();
	}

	switchTo(locale:string):void{
		if(locale===this.currentLocale) return;
		// Remembered server-side on the next visit: the SSR locale redirect reads
		// this cookie ahead of the Accept-Language header.
		this.cookieService.set('locale',locale,{path:'/',expires:365,sameSite:'Lax'});
		const {pathname,search,hash}=this.document.location;
		// Matches a bare `/en` as well as `/en/...`, so switching from a locale root works.
		const localePathRegex=new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})(/|$)`);
		const newPath=localePathRegex.test(pathname)
			? pathname.replace(localePathRegex,`/${locale}$2`)
			: `/${locale}${pathname}`;
		this.document.location.href=`${newPath}${search}${hash}`;
	}
}
